import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ecms.licensing.client';
  public static path: string = "https://localhost:7243";
}
//ng build --base-href http://194.146.42.127